import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = ['$scope', '$timeout', '$uibModalInstance', 'modalOptions', 'SharedService', 'SessionService', '$state', '$uibModal','CartService','ngAuthSettings','$window'];

class ModalConfirmationMoraController {
    constructor($scope, $timeout, $uibModalInstance, modalOptions, SharedService, SessionService, $state, $uibModal,CartService,ngAuthSettings,$window) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.SharedService = SharedService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.$uibModalInstance = $uibModalInstance;
        this.$uibModal = $uibModal;
        this.modalOptions = Object.assign({}, modalOptions);
        this.state = {};
        this.branchUserB2B = {};
        this.registerDataForm = {};
        this.CartService = CartService;
        this.messageBody = '';
        this.ngAuthSettings = ngAuthSettings;
        this.mensajeMora = '';
        this.$window = $window;
    }

    $onInit() {
        this.mensajeMora = this.modalOptions.params.cmsInfo.B2B_MENSAJE_INFORMATIVO_PAGAR_MORA;
    }
    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    ok() {
        this.$uibModalInstance.close(this.$scope);
    }

    redirigirZonaPagos(){
        this.state.saving = true;
        let emailUser = this.modalOptions.globals.currentUser.contactEmail;
        let urlAgr = this.modalOptions.ngAuthSettings.site.info.company.urlAgp;

        this.CartService.createToken(emailUser).then(response => {
          if (!response.error) {
            this.state.saving = false;
            let token = response.token;
            this.cancel();
            // Si la url no esta parametrizada mostramos el error
            if(urlAgr != null && urlAgr != ''){
              // Si no contiene http la url se lo añadimos 
              if (urlAgr.substring(0, 4) !== 'http'){
                urlAgr = 'http://' + urlAgr;
              }
              let urlZonaPagos = urlAgr + '/token/' + token;
              this.$window.open(urlZonaPagos, '_blank');
            }else{
              let options = {
                title: 'Error',
                isHtml: false,
                content: 'Ha ocurrido un error al redirigir a zona de pagos',
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              this.messageResponse(options);  
            }
          } else {
            this.state.saving = false;
            let options = {
              title: 'Error',
              isHtml: false,
              content: 'Ha ocurrido un error al redirigir a zona de pagos',
              size: '',
              showBottonCancel: false,
              textActionCancel: '',
              textAction: 'Aceptar'
            };
            this.messageResponse(options);
          }
        });
    }

    consultarCartera(){
        try {
            this.state.mora = true;
            let data = {
              idCia: 1,
              nit: this.modalOptions.globals.currentClient.third.documentNumber,
              idSucursal: this.modalOptions.globals.currentClient.operatingCenter.code,
              moneda: 'COP'
            };
      
            this.CartService.getDebtsToPay(data).then(billfoldResume => {
              this.state.mora = false;
              let valorMora = billfoldResume.data.cartera_vencida;
              valorMora = parseInt(valorMora);
              
              if(valorMora <= 0){
                this.cancel();
              }
      
            })
            .catch(error => {
              console.log(error);
            });
      
          }
          catch (e) {
            // ...
          }
    }
}

ModalConfirmationMoraController.$inject = inject;

export default ModalConfirmationMoraController;


/** WEBPACK FOOTER **
 ** ./www/components/confirmation-order/modal-confirmation-mora/modal-confirmation-mora.controller.js
 **/